import React from 'react';
import formatAmount from '../../utils/formatAmount';





const OrderLIne = ({cart, onClick, is_refund}) => {
  const { name, sales_price, quantity, select, subtotal } = cart;
  return (
    <div className={select ? 'bg-gray-300 '+'hover:cursor-pointer p-2 pt-0' : 'p-2 pt-0 hover:cursor-pointer hover:bg-gray-200'} onClick={()=>onClick(cart)}>
      <div className='flex justify-between font-bold'>
        <h5>{name}</h5>
        <span>GHc {formatAmount(is_refund ? subtotal * -1 : subtotal * 1)}</span>
      </div>
      <div>
        <p>
          <span className='me-2 font-semibold'>{formatAmount(is_refund ? quantity * -1 : quantity * 1)}</span>
           Units at GHc {formatAmount(sales_price)} / Units
        </p>
      </div>
    </div>
  )
}

export default OrderLIne;